import { P2GGrid } from '@parcel2go/core-ui';
import { Product, ProductSlots } from '../adapters/product-types';
import { ProductSummary } from '../summary/product-summary';
import { Fragment } from 'react/jsx-runtime';

type ProductListViewProps = {
  product: Product;
  slots?: ProductSlots;
};

export function ProductListView({ product, slots }: ProductListViewProps) {
  return (
    <P2GGrid container direction="column" spacing={2} wrap="nowrap">
      {product.items.map((item, i) => (
        <Fragment key={item.id}>
          {slots?.['product-item-id']?.(item)}
          <P2GGrid item>
            <ProductSummary item={item} currency={product.currency} slots={slots} index={i} />
          </P2GGrid>
        </Fragment>
      ))}
    </P2GGrid>
  );
}
